"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Checkbox = _interopRequireDefault(require("@airasia/phoenix-components/components/Checkbox"));

var _snapCheckbox = _interopRequireDefault(require("./snapCheckbox.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "SnapCheckbox__Wrapper",
  componentId: "sc-1qje2i4-0"
})(["display:flex;align-items:center;flex-direction:row;cursor:pointer;width:fit-content;pointer-events:", ";border:1px solid ", ";border-radius:", ";position:relative;min-width:", ";padding:", " ", ";background-color:", ";"], function (_ref) {
  var disable = _ref.disable;
  return disable && 'none';
}, function (props) {
  return props.theme.colors.greyMedium;
}, function (props) {
  return props.theme.borderRadius.small;
}, _constant.WIDTH, function (props) {
  return props.theme.space.XSmall;
}, function (props) {
  return props.theme.space.XXXSmall;
}, function (props) {
  return props.theme.backgroundColor.primary;
});

var TitleWrapper = _styledComponents.default.div.withConfig({
  displayName: "SnapCheckbox__TitleWrapper",
  componentId: "sc-1qje2i4-1"
})(["position:absolute;top:", ";left:", ";background-color:#dc3224;border-radius:", ";padding:0px ", ";"], _constant.TITLE_TEXT_STYLE.OFFSET_TOP, function (props) {
  return props.theme.space.semiMedium;
}, function (props) {
  return props.theme.borderRadius.small;
}, function (props) {
  return props.theme.space.micro;
});

var SnapCheckbox = function SnapCheckbox(_ref2) {
  var theme = _ref2.theme,
      isSelected = _ref2.isSelected,
      onChange = _ref2.onChange,
      text = _ref2.text,
      titleText = _ref2.titleText,
      accessible = _ref2.accessible,
      disableBottomMargin = _ref2.disableBottomMargin,
      disableCheckbox = _ref2.disableCheckbox,
      customProperties = _ref2.customProperties;

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(TitleWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: true,
      color: _constant.TITLE_TEXT_STYLE.COLOR,
      type: _constant.TITLE_TEXT_STYLE.TYPE
    }, titleText)), /*#__PURE__*/_react.default.createElement(_Checkbox.default, (0, _extends2.default)({
      accessible: accessible,
      disableBottomMargin: disableBottomMargin,
      disableCheckbox: disableCheckbox,
      isSelected: isSelected,
      onChange: onChange,
      text: text,
      theme: theme
    }, customProperties)));
  };

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

SnapCheckbox.propTypes = _snapCheckbox.default.PropTypes;
SnapCheckbox.defaultProps = _snapCheckbox.default.DefaultProps;
var _default = SnapCheckbox;
exports.default = _default;